import React from 'react';
import { Home, Building2, Loader2 } from 'lucide-react';

export const STAGE_COLORS = {
  contacto_nuevo: 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30',
  interesado: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
  pendiente_instalacion_prueba: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  prueba_activa: 'bg-purple-500/15 text-purple-300 border-purple-500/30',
  pendiente_contrato: 'bg-orange-500/15 text-orange-300 border-orange-500/30',
  cliente: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  pendiente_retirada: 'bg-red-500/15 text-red-300 border-red-500/30',
  perdido: 'bg-zinc-700/30 text-zinc-500 border-zinc-600/30',
};

export function StageBadge({ stage, label }) {
  return (
    <span className={`px-2.5 py-1 text-xs font-medium rounded-full border ${STAGE_COLORS[stage] || STAGE_COLORS.contacto_nuevo}`}>
      {label}
    </span>
  );
}

export function TipoClienteIcon({ tipo }) {
  return (
    <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${tipo === 'empresa' ? 'bg-amber-500/20' : 'bg-sky-500/20'}`}>
      {tipo === 'empresa' ? (
        <Building2 className="w-4 h-4 text-amber-400" />
      ) : (
        <Home className="w-4 h-4 text-sky-400" />
      )}
    </div>
  );
}

export function LoadingState() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Loader2 className="w-8 h-8 text-sky-400 animate-spin" />
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {Icon && (
        <div className="w-16 h-16 rounded-2xl bg-white/[0.03] border border-white/[0.06] flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-zinc-600" />
        </div>
      )}
      <h3 className="text-lg font-light text-white font-['Outfit'] mb-2">{title}</h3>
      {description && <p className="text-sm text-zinc-500 max-w-md font-['Manrope']">{description}</p>}
    </div>
  );
}

export function FilterChip({ active, onClick, children, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`px-3 py-1.5 text-xs font-medium rounded-full border transition-colors ${
        active
          ? 'bg-white text-black border-white'
          : 'bg-white/[0.03] text-zinc-400 border-white/10 hover:text-white hover:border-white/30'
      }`}
    >
      {children}
    </button>
  );
}
